import { supabase } from './supabase'

export interface MasterclassRegistration {
  id?: string
  full_name: string
  email: string
  business_type: string
  biggest_challenge?: string
  track_preference?: string
  created_at?: string
}

const STORAGE_KEY = 'masterclass_registrations'

export const masterclassService = {
  async register(data: Omit<MasterclassRegistration, 'id' | 'created_at'>) {
    if (supabase) {
      try {
        const { data: result, error } = await supabase
          .from('masterclass_registrations')
          .insert([{
            full_name: data.full_name,
            email: data.email,
            business_type: data.business_type,
            biggest_challenge: data.biggest_challenge || null,
            track_preference: data.track_preference || 'undecided',
          }])
          .select()
          .single()

        if (error) {
          // Handle duplicate email
          if (error.code === '23505') {
            return { success: false, duplicate: true }
          }
          throw error
        }
        return { success: true, data: result }
      } catch (error: any) {
        if (error?.code === '23505') {
          return { success: false, duplicate: true }
        }
        console.error('Supabase registration error:', error)
        // Fall through to localStorage
      }
    }

    // localStorage fallback
    const registrations: MasterclassRegistration[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '[]'
    )

    // Check duplicate
    if (registrations.some(r => r.email === data.email)) {
      return { success: false, duplicate: true }
    }

    const registration: MasterclassRegistration = {
      ...data,
      id: crypto.randomUUID(),
      created_at: new Date().toISOString(),
    }

    registrations.push(registration)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(registrations))
    return { success: true, data: registration }
  },

  async checkRegistration(email: string): Promise<boolean> {
    if (supabase) {
      try {
        const { data, error } = await supabase
          .from('masterclass_registrations')
          .select('id')
          .eq('email', email)
          .single()

        if (!error && data) return true
      } catch {
        // Fall through to localStorage
      }
    }

    const registrations: MasterclassRegistration[] = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '[]'
    )
    return registrations.some(r => r.email === email)
  },
}
